import React, { useState } from "react";
import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  const [click, setClick] = useState(false);
  const changeColor = () => {
    if (window.scrollY >= 90) {
      setClick(true);
    } else {
      setClick(false);
    }
  };
  window.addEventListener("scroll", changeColor);

  return (
    <div className={click ? "ps-3 pe-3 head head-bg" : "ps-3 pe-3 head"}>
      <Nav class="navbar navbar-expand-lg navbar-dark ">
        <div class="container-fluid">
          <Nav.Link class="navbar-brand" active id="navv" as={Link} to="/">
            {"< Riyad />"}
          </Nav.Link>
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarNavDropdown">
            <ul class="navbar-nav ms-auto mb-2 mb-lg-0 naav">
              <Nav.Link
                class="  naav"
                active
                aria-current="page"
                as={Link}
                to="/"
              >
                <small className="fs-4">Home</small>
              </Nav.Link>

              <li class="nav-item naav ms-5">
                <Nav.Link class="nav-link active  naav" active href="#aboutt">
                  <small className="fs-4">About</small>
                </Nav.Link>
              </li>
              <li class="nav-item naav ms-5">
                <Nav.Link active href="#projects">
                  <small className="fs-4">Projects</small>
                </Nav.Link>
              </li>
              <li class="nav-item  ms-5">
                <Nav.Link
                  id=" naav"
                  class="nav-link active"
                  active
                  href="#contact"
                >
                  <small className="fs-4">Contact</small>
                </Nav.Link>
              </li>
              {/* <li class="nav-item  ms-5">
                            <a href='https://drive.google.com/u/0/uc?id=1ntl5qJdJD0sr8kiQQSx9p76GrjLHPPy8&export=download' role='button' target='_blank' className='btn btnn mt-3 text-white fw-bold fs-5  ms-4 '><i class="fas fa-file-download me-1"></i>Resume</a>
                            </li> */}
            </ul>
          </div>
        </div>
      </Nav>
    </div>
  );
};

export default Navbar;
